import { z } from 'zod';

export const quizScoreTableSchema = z.object({
  type: z.literal('quizScore'),
  data: z.array(
    z.object({
      student: z.object({
        id: z.string(),
        lastName: z.string(),
        firstName: z.string(),
      }),
      score: z.number().nullable(),
    })
  ),
});

export type QuizScoreTableResponse = z.infer<typeof quizScoreTableSchema>;
